import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Aurora from "@/components/common/Aurora";
import Logo from "@/components/common/Logo";
import Button from "@/components/ui/Button";

export default function NotFound() {
  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-slate-50 px-6 text-center dark:bg-ink-950">
      <Aurora />
      <div className="relative">
        <Link to="/" className="inline-flex">
          <Logo />
        </Link>
        <h1 className="mt-10 font-display text-7xl font-bold gradient-text">404</h1>
        <p className="mt-4 text-lg font-semibold text-slate-900 dark:text-white">
          This page wandered off.
        </p>
        <p className="mt-1.5 text-sm text-slate-500 dark:text-slate-400">
          The page you&apos;re looking for doesn&apos;t exist or moved.
        </p>
        <Button to="/" className="mt-8">
          <ArrowLeft size={18} /> Back home
        </Button>
      </div>
    </div>
  );
}
